const themeLightStateFocus = '#1A44EA';

export { themeLightStateFocus };
